import React, { useEffect, useRef, useState } from "react";
import { render, unmountComponentAtNode } from "react-dom";
// import PackageSection from "../packages/PackageSection";
import Heart from "../heart";
import Collapse from "bootstrap/js/src/collapse";
import { apiURL } from "../../helpers/url";
import Preview from "../preview";
import ProductRating from "../productrating";
import NewCartButton from "../cartbutton/NewCartButton";
import { isEmpty } from "lodash";

function PackagePage(props) {
    const packageJson = props.elem?.dataset?.package;

    const carouselRef = useRef();
    const collapseBookListRef = useRef();
    const [showBookList, setShowBookList] = useState(false);
    const [bsCollapse, setBsCollapse] = useState(null);
    const [showDescription, setShowDescription] = useState(false);
    const [selectedBookIndex, setSelectedBookIndex] = useState(0);
    const [selectedBook, setSelectedBook] = useState(() => {});

    const [packageData, setPackageData] = useState(() => []);
    const [packageBooks, setPackageBooks] = useState(() => []);
    const [authors, setAuthors] = useState(() => []);

    const selectBookHandler = (key) => {
        setSelectedBookIndex(key);
        setSelectedBook(packageBooks[key]);
    };

    useEffect(() => {
        const fetchPackage = async () => {
            const packageData = JSON.parse(packageJson);
            
            setPackageData(packageData);
            setPackageBooks(packageData?.package_items);
            setSelectedBook(packageData?.package_items[0]);
            setAuthors(packageData?.package_items.reduce((authors, item) => {
                if (item.authors && Array.isArray(item.authors)) {
                  item.authors.forEach(author => {
                    if (!authors.some(existingAuthor => existingAuthor.id === author.id)) {
                      authors.push(author);
                    }
                  });
                }
                return authors;
            }, []));
        };

        fetchPackage();
    }, []);

    useEffect(() => {
        setBsCollapse(new Collapse(collapseBookListRef.current, { toggle: false }));
        $('[data-toggle="tooltip"]').tooltip();
    }, []);

    useEffect(() => {
        if (packageBooks.length !== 0) {
            scrollTo(selectedBookIndex);
        }
    }, [selectedBookIndex, packageBooks]);

    useEffect(() => {
        let previewElem = document.querySelector(".widget-preview");
        if (previewElem) {
            window.Dibook.preview.widget = {
                open: (bookId) => {
                    render(<Preview elem={previewElem} bookId={Number(bookId)} />, previewElem);
                },
                close: () => unmountComponentAtNode(previewElem),
            };
        }
    }, [selectedBook]);

    return (
        <div className="">
            <div className="container">
                <div className="row pt-5">
                    <div className="mx-auto pb-5">
                        <img src={packageData.cover} alt="Placeholder Image" width="244" height="330" />
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <div className="package-data__header">
                                    <h4 style={{ fontSize: "20px", color: "#1A1A1A" }}>
                                        {packageData.title}
                                    </h4>
                                    <div className="pt-1 pb-1">
                                        {packageBooks.length === 0 && <span>Nincs könyv a csomagban.</span>}
                                        {authors.map((author, authorIndex) => 
                                            <span key={author.id} style={{ display: "inline-flex", alignItems: "center", marginRight: "8px" }}>
                                                <a href={author.url} style={{ marginRight: "4px" }}>
                                                    {author.fullName}
                                                </a>
                                                <Heart type={"author"} id={author.id} />
                                                {authorIndex < authors.length - 1 && ', '}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex pt-2">
                                    <section className="faq-section bg-transparent w-100">
                                        <div 
                                            className="package-data__content" 
                                            dangerouslySetInnerHTML={{ __html: packageData.description }}
                                        />
                                        <div className="container">
                                            <div className="faq-section-questions d-flex flex-column w-100">
                                                <div className="faq-section-questions-col">
                                                    <div className="catalog-division-head">
                                                        <div
                                                            className="catalog-division-title"
                                                            onClick={() => setShowDescription(!showDescription)}
                                                            style={{ cursor: "pointer" }} // Jelezze, hogy kattintható
                                                        >
                                                            Mi tudható a csomagajánlatokról?
                                                            <span className={`toggle-icon ${showDescription ? "expanded" : ""}`} />
                                                        </div>
                                                        <div
                                                            className={`catalog-division-lead ${showDescription ? "show" : "collapse"}`}
                                                        >
                                                            <h4 className="pt-4 pb-3">
                                                                A magyar e-könyves piacon elsőként nálunk már csomagban is vásárolhatsz!
                                                            </h4>
                                                            <p>
                                                                Csak tedd Kosárba a csomagot, majd fizesd ki, és már tied is a csomag tartalma.
                                                                A csomag tartalmát a csomagra kattintva találod, ha egyenként a kis borítókra kattintasz, akkor a könyvek fülszövegét és adatait is megismerheted.
                                                            </p>
                                                            <p>
                                                                A csomagárat személyre szabtuk. Ha eddig még egy könyvet sem vettél meg a csomagból a DiBookon, akkor a csomag mellett az összes könyvre vonatkozó kedvezményes árat látod. Ha van olyan könyv a csomagban, amelyet korábban már megvásároltál a DiBookon, akkor az a termék elhalványítva látható, az árát pedig nem számoljuk bele a neked szóló csomagajánlatba, hogy bátran megvehesd a csomagot akkor is, ha egy-két könyv belőle már ott csücsül a virtuális polcodon.
                                                            </p>
                                                            <p>
                                                                A csomag megvásárlása után az adott csomag eltűnik a csomagajánlatok közül, mert kétszer nem tudod megvenni ugyanazt a csomagot. Csomagvásárláskor kupon nem használható fel.
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                            <div className="col-12 col-md-5 col-lg-4 col-xl-3 package-product__actions-wrapper">
                                {(packageData.finalprice || packageData.price) && 
                                <div className="product-action new-product-action">
                                    <div className="row d-flex align-items-center">
                                        <div className="col">
                                            <p style={{ fontWeight: "700", fontSize: "17px", marginBottom: "0", textAlign: 'end' }} className="mb-1">
                                                {packageData?.package_type === 1 ? "E-könyv-csomag" : "Hangoskönyv csomag"}
                                            </p>
                                            <div className="d-flex align-items-center text-end" style={{ gap: 10, padding: "0" }}>
                                                <div
                                                    className="product-price"
                                                    style={{ flex: 1, minWidth: "fit-content" }}
                                                >
                                                    {packageData.finalprice !== packageData.price && (
                                                        <span className="product-old-price" style={{textAlign: "end"}}>
                                                            {window.Dibook.language.formatCurrency(packageData.price)}
                                                        </span>
                                                    )}
                                                    <span className="product-new-price" style={{textAlign: "end"}}>
                                                        {packageData.finalprice
                                                            ? window.Dibook.language.formatCurrency(packageData.finalprice)
                                                            : window.Dibook.language.formatCurrency(packageData.price)}

                                                        {!!packageData.points && (
                                                            <p className="font-weight-normal m-0" style={{textAlign: "end"}}>{packageData.points + " pont"}</p>
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <NewCartButton
                                            owned={packageData.purchased}
                                            id={packageData.id}
                                            full
                                        />
                                    </div>
                                </div>}
                                <ProductRating {...props.elem.dataset} />
                            </div>
                        </div>
                        <div className="package-product__book-list">
                            <div className="package-product__book-list__header" onClick={toggleBookList}>
                                <span className="package-product__book-list__header__text">
                                    A csomag tartalma
                                </span>
                                <span
                                    className={
                                        "package-product__book-list__header__icon" +
                                        (showBookList
                                            ? " package-product__book-list__header__icon_expanded"
                                            : "")
                                    }
                                ></span>
                            </div>
                            <div className="package-product__book-list__body">
                                <div className="collapse" id="collapseBookList" ref={collapseBookListRef}>
                                    {packageBooks.map((item, key) => (
                                        <div
                                            key={item.id}
                                            className={
                                                "package-product__book-list__item" +
                                                (key === selectedBookIndex
                                                    ? " package-product__book-list__item_selected"
                                                    : "")
                                            }
                                            onClick={selectBookHandler.bind(null, key)}
                                        >
                                            <span className="package-product__book-list__item__title">
                                                {item.title}
                                            </span>
                                            {(item.authors && item.authors.length > 0) && (
                                                <span className="package-product__book-list__item__author">
                                                    {item.authors[0].firstname} {item.authors[0].lastname}
                                                </span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5 package-product__book-cards">
                    {packageBooks.map((item, key) => (
                        <div
                            key={item.id}
                            className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                            style={
                                item.purchased
                                    ? { opacity: 0.6, display: "flex", alignItems: "stretch" }
                                    : { display: "flex", alignItems: "stretch" }
                            }
                        >
                            <div
                                className={
                                    "package-product__book-cards__item" +
                                    (key === selectedBookIndex
                                        ? " package-product__book-cards__item_selected"
                                        : "")
                                }
                                onClick={selectBookHandler.bind(null, key)}
                            >
                                <img
                                    className="package-product__book-cards__item__img"
                                    src={item.cover}
                                    alt="book"
                                />
                                <span className="package-product__book-cards__item__title">
                                    {item.title}
                                </span>
                                {(item.authors && item.authors.length > 0) &&
                                    <a
                                        href="#"
                                        className="package-product__book-cards__item__author"
                                        style={{ marginTop: "auto" }}
                                    >
                                        {item.authors[0].lastname} {item.authors[0].firstname} 
                                    </a>
                                }
                            </div>
                        </div>
                    ))}
                </div>
                <div className="product-head container p-0 mt-5">
                    <ul className="bc product-bc">
                        {!isEmpty(packageData) ? 
                        <li>
                            {packageData?.package_type === 1 ? (
                                <a href="#" style={{fontWeight: 200}}>E-könyv</a>
                            ) : (
                                <a href="#" style={{fontWeight: 200}}>Hangoskönyv</a>
                            )}
                        </li> :
                        <li className="mb-5">
                            <a href="#" style={{fontWeight: 200}}>Betöltés...</a>
                        </li>}
                        {Object.keys(selectedBook?.categories ?? {}).length > 0 ? (
                            <>
                                <li>
                                    {selectedBook?.categories.map((item, key) =>
                                        key !== 0 ? (
                                            <a key={key} href="#" style={{fontWeight: 200}}>
                                                , {item.category.name}
                                            </a>
                                        ) : (
                                            <a key={key} href="#" style={{fontWeight: 200}}>
                                                {item.category.name}
                                            </a>
                                        )
                                    )}
                                </li>
                            </>
                        ) : null}
                    </ul>
                </div>
            </div>
            <div className="package-product__carousel">
                <div className="package-product__carousel__controller">
                    {selectedBookIndex !== 0 && (
                        <div
                            className="package-product__carousel__controller__btn package-product__carousel__controller__btn_left"
                            onClick={goPrev}
                        ></div>
                    )}
                    {selectedBookIndex !== packageBooks.length - 1 && (
                        <div
                            className="package-product__carousel__controller__btn package-product__carousel__controller__btn_right"
                            onClick={goNext}
                        ></div>
                    )}
                </div>
                <div ref={carouselRef} className="package-product__carousel__body">
                    {packageBooks.map((item, key) => (
                        <div key={key} className="package-product__carousel__body__item">
                            <img
                                className="package-product__carousel__body__item__img"
                                src={item.cover}
                                alt="book"
                            />
                        </div>
                    ))}
                </div>
            </div>
            {!isEmpty(packageData) && 
            <div className="container">
                <div className="row mt-4" style={{ marginBottom: "30px" }}>
                    <div className="col-12 col-lg-3">
                        <div className="package-product-img">
                            <img
                                src={selectedBook?.cover}
                                style={{ width: 100 + "%", height: "auto" }}
                                alt="bookcover"
                            />
                        </div>
                        <ProductRating
                            rating={"" + selectedBook?.rating.average}
                            ratingamount={"" + selectedBook?.rating.rateamount}
                            bookid={"" + selectedBook?.id}
                            login="1"
                            notext="true"
                        />
                    </div>
                    <div className="col-lg-6 px-3">
                        <a href={selectedBook?.url}>
                            <h1 className="package-product-title title-with-icon">
                                {selectedBook?.title}
                            </h1>
                        </a>
                        <span
                            className={`title-icon big ${
                                selectedBook?.type === 2
                                    ? "teaser-audio-btn audio"
                                    : "teaser-btn ebook"
                            }`}
                            style={{ cursor: "pointer" }}
                            data-toggle="tooltip"
                            data-placement="top"
                            title={selectedBook?.type === 1 ? "Beleolvasó" : "Belehallgatok"}
                        />
                        {selectedBook?.type === 2 && <div id="audio-preview"></div>}
                        <div className="widget-preview"></div>
                        <h3 className="package-product-subtitle">{selectedBook?.subtitle}</h3>
                        <h2 className="package-product-author">
                            {selectedBook?.authors
                                ? selectedBook?.authors.map((author, key) => (
                                      <div
                                          key={key}
                                          style={{ display: "flex", alignItems: "center" }}
                                      >
                                          <a href={author.url} style={{fontWeight: 400}}>{author.fullName}</a>
                                          <Heart type={"author"} id={author.id} />
                                      </div>
                                  ))
                                : ""}
                        </h2>
                        <div className="package-product-lead">
                            <div
                                className={
                                    "package-product-lead--content-wrapper" +
                                    (showDescription
                                        ? " package-product-lead--content-wrapper_show"
                                        : "")
                                }
                                style={{borderTop: "1px solid #DEE2E6"}}
                            >
                                <div
                                    className="package-product-lead--content"
                                    dangerouslySetInnerHTML={{
                                        __html: selectedBook?.description,
                                    }}
                                    style={{fontWeight: 400}}
                                />
                            </div>
                            <div
                                className={
                                    "package-product-lead--opener" +
                                    (showDescription ? " package-product-lead--opener_show" : "")
                                }
                                onClick={() => setShowDescription(!showDescription)}
                            ></div>
                        </div>
                        <h4 style={{fontWeight: 250}}>További információk</h4>
                        <div className="new-product-details">
                            <ul className="product-details-items">
                                {(selectedBook?.series || selectedBook?.series_num) && (
                                <>
                                    <li className="product-details-item">
                                        <div className="product-details-item-name">
                                            <img src="/images/icon/bookmark-icon.svg" alt="bookmark-icon" />
                                            <p>sorozat</p>
                                        </div>
                                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                            <a className="product-details-item-value">
                                                {selectedBook?.serie?.title}
                                            </a>
                                        </div>
                                    </li>
                                    <li className="product-details-item">
                                        <div className="product-details-item-name">
                                            <img src="/images/icon/bookmark-alt-icon.svg" alt="bookmark-alt-icon" />
                                            <p>kötet</p>
                                        </div>
                                        <p className="product-details-item-value">{Math.floor(selectedBook?.series_num)}</p>
                                    </li>
                                </>
                                )}

                                <li className="product-details-item">
                                    <div className="product-details-item-name">
                                        <img src="/images/icon/publisher-icon.svg" alt="publisher icon" />
                                        <p>kiadó</p>
                                    </div>
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ gap: 4 }}
                                    >
                                        <a
                                            className="product-details-item-value"
                                            href={selectedBook?.publisher?.url}
                                        >
                                            {selectedBook?.publisher?.name}
                                        </a>
                                    </div>
                                </li>

                                {!!selectedBook?.publish_year && (
                                    <>
                                        <li className="product-details-item">
                                            <div className="product-details-item-name">
                                                <img
                                                    src="/images/icon/calendar-icon.svg"
                                                    alt="calendar icon"
                                                />
                                                <p>megjelenés</p>
                                            </div>
                                            <p className="product-details-item-value">
                                                {selectedBook?.publish_year}
                                            </p>
                                        </li>
                                    </>
                                )}
                                {!!selectedBook?.pagenum && (
                                    <>
                                        <li className="product-details-item">
                                            <div className="product-details-item-name">
                                                <img
                                                    src="/images/icon/document-icon.svg"
                                                    alt="document icon"
                                                />
                                                <p>hossz</p>
                                            </div>
                                            <p className="product-details-item-value">
                                                {selectedBook?.pagenum} oldal
                                            </p>
                                        </li>
                                    </>
                                )}
                                {!!selectedBook?.genres[0] && (
                                    <>
                                        <li className="product-details-item">
                                            <div className="product-details-item-name">
                                                <img
                                                    src="/images/icon/genre-icon.svg"
                                                    alt="genre icon"
                                                />
                                                <p>műfaj</p>
                                            </div>
                                            <p className="product-details-item-value">
                                                {selectedBook?.genres[0].genre.name}
                                            </p>
                                        </li>
                                    </>
                                )}
                                <li className="product-details-item">
                                    <div className="product-details-item-name">
                                        <img src="/images/icon/language-icon.svg" alt="language icon" />
                                        <p>nyelv</p>
                                    </div>
                                    <p className="product-details-item-value">
                                        {selectedBook?.language.name}
                                    </p>
                                </li>

                                <li className="product-details-item" style={{ maxWidth: 125 }}>
                                    <div className="product-details-item-name">
                                        <img src="/images/icon/barcode-icon.svg" alt="barcode icon" />
                                        <p>ISBN</p>
                                    </div>
                                    <span className="product-details-item-value">
                                        {selectedBook?.isbn}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>}
            {/* <PackageSection title="Hangoskönyvek" responsive={false} /> */}
        </div>
    );

    async function toggleBookList() {
        if (showBookList) await bsCollapse.hide();
        else await bsCollapse.show();
        setShowBookList(!showBookList);
    }

    function goPrev() {
        if (selectedBookIndex === 0) return;
        setSelectedBookIndex((val) => {
            selectBookHandler(val - 1);
            return val - 1;
        });
    }

    function goNext() {
        if (selectedBookIndex === packageBooks.length - 1) return;
        setSelectedBookIndex((val) => {
            selectBookHandler(val + 1);
            return val + 1;
        });
    }

    function scrollTo(index) {
        const item = document.querySelector(".package-product__carousel__body__item");

        if (item === null) {
            return;
        }

        const itemWidth = item.getBoundingClientRect().width;
        const scrollWidth = itemWidth + 16; // 16 is column width and if changed here should be changed in css too //didn't want to set it with js
        carouselRef.current.scrollTo(scrollWidth * index, 0);
    }
}

export default PackagePage;
